import { ElementType, HTMLAttributes, ReactNode } from "react";
import { classNames } from "@ct-react/core";
import * as stickable from "./stickable-box";
import * as collapse from "./collapse";
import * as slidable from "./slidable-box";
import * as modal from "./modal";
import "./index.scss";

type AnyWrapperProps<T = ReactNode | undefined> = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
  children: T;
};

const toDomElement = <T = ReactNode | undefined>(...classes: string[]) => (
  {
    as: Tag = "div",
    className,
    children,
    ...others
  }: AnyWrapperProps<T>) => {
  const wrapperClasses = classNames(classes, className);
  return (<Tag className={wrapperClasses} {...others}>{!!children && children}</Tag>);
}

export namespace Wrapper {
  export const Centered = toDomElement("wrap", "centered");
  export const StickableBox = stickable.default;
  export const Collapse = collapse.default;
  export const CollapseItem = collapse.CollapseItem;
  export const SlidableBox = slidable.default;
  export const SlidableItem = slidable.SlidableItem;
  export const Modal = modal.default;
  export const ModalTrigger = modal.ModalTrigger;
  export const ModalContent = modal.ModalContent;
  export const ModalFooter = modal.ModalFooter;
}

export const StickableContext = stickable.StickableContext;
